import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { NotificationsState } from './types';

const initState = () => {
    return new  NotificationsState();
};

export const useNotificationsStore = createStoreModule<NotificationsState, IAction<NotificationsState>>(initState, 'root-Notifications');
